export default "__VITE_ASSET__D6sBVjVg__"